export default __webpack_public_path__ + "static/media/how-works-img.04c46175.svg";